import React from 'react';
import { Box, Button, Alert, AlertTitle, Container } from '@mui/material';
import { useAppContext } from './AppContext';

const Unauthorized = () => {
  const { t } = useAppContext();
  const handleGoBack = () => {
    window.history.back(); // Go back to the previous page
  };

  return (
    <Container>
        <Box mt={3}>
    <Alert severity="error">
  <AlertTitle>{t('Unauthorized Access')}</AlertTitle>
  {t('You do not have permission to access this page.')}
</Alert><Button 
        variant="outlined" 
        color="error" 
        onClick={handleGoBack}
        sx={{marginTop:'10px'}}
      >
        {t('Go Back')}
      </Button>

</Box>
</Container>
  );
};

export default Unauthorized;
